import {
  SET_CURRENCY_RATE_REQUEST,
  SET_CURRENCY_RATE_SUCCESS,
  SET_CURRENCY_RATE_FAIL,
  SET_CURRENCY_RATE_LOADING,
  CLEAR_SET_CURRENCY_RATE_SUCCESS,
  SET_SYSTEM_CURRENCY_REQUEST,
  SET_SYSTEM_CURRENCY_SUCCESS,
  SET_SYSTEM_CURRENCY_FAIL,
  SET_SYSTEM_CURRENCY_LOADING,
  CLEAR_SET_SYSTEM_CURRENCY_SUCCESS,
  GET_CURRENCY_RATES_REQUEST,
  GET_CURRENCY_RATES_SUCCESS,
  GET_CURRENCY_RATES_FAIL,
  GET_CURRENCY_RATES_LOADING,
  GET_SYSTEM_CURRENCY_REQUEST,
  GET_SYSTEM_CURRENCY_SUCCESS,
  GET_SYSTEM_CURRENCY_FAIL,
  GET_SYSTEM_CURRENCY_LOADING,
  DEACTIVATE_CURRENCY_RATE_REQUEST,
  DEACTIVATE_CURRENCY_RATE_SUCCESS,
  DEACTIVATE_CURRENCY_RATE_FAIL,
  DEACTIVATE_CURRENCY_RATE_LOADING,
  DELETE_CURRENCY_RATE_REQUEST,
  DELETE_CURRENCY_RATE_SUCCESS,
  DELETE_CURRENCY_RATE_FAIL,
  DELETE_CURRENCY_RATE_LOADING,
} from "../types";

// Set Currency Rate Actions
export const setCurrencyRateRequest = (prop) => {
  return {
    type: SET_CURRENCY_RATE_REQUEST,
    payload: prop,
  };
};

export const setCurrencyRateSuccess = (prop) => {
  return {
    type: SET_CURRENCY_RATE_SUCCESS,
    payload: prop,
  };
};

export const clearSetCurrencyRateSuccess = () => {
  return {
    type: CLEAR_SET_CURRENCY_RATE_SUCCESS,
  };
};

export const setCurrencyRateFailure = (errors) => {
  return {
    type: SET_CURRENCY_RATE_FAIL,
    payload: { errors },
  };
};

export const setCurrencyRateLoading = (loading) => {
  return {
    type: SET_CURRENCY_RATE_LOADING,
    payload: loading,
  };
};

// Set System Currency Actions
export const setSystemCurrencyRequest = (prop) => {
  return {
    type: SET_SYSTEM_CURRENCY_REQUEST,
    payload: prop,
  };
};

export const setSystemCurrencySuccess = (prop) => {
  return {
    type: SET_SYSTEM_CURRENCY_SUCCESS,
    payload: prop,
  };
};

export const clearSetSystemCurrencySuccess = () => {
  return {
    type: CLEAR_SET_SYSTEM_CURRENCY_SUCCESS,
  };
};

export const setSystemCurrencyFailure = (errors) => {
  return {
    type: SET_SYSTEM_CURRENCY_FAIL,
    payload: { errors },
  };
};

export const setSystemCurrencyLoading = (loading) => {
  return {
    type: SET_SYSTEM_CURRENCY_LOADING,
    payload: loading,
  };
};

// Get Currency Rates Actions
export const getCurrencyRatesRequest = () => {
  return {
    type: GET_CURRENCY_RATES_REQUEST,
  };
};

export const getCurrencyRatesSuccess = (prop) => {
  return {
    type: GET_CURRENCY_RATES_SUCCESS,
    payload: prop,
  };
};

export const getCurrencyRatesFailure = (errors) => {
  return {
    type: GET_CURRENCY_RATES_FAIL,
    payload: { errors },
  };
};

export const getCurrencyRatesLoading = (loading) => {
  return {
    type: GET_CURRENCY_RATES_LOADING,
    payload: loading,
  };
};

// Get System Currency Actions
export const getSystemCurrencyRequest = () => {
  return {
    type: GET_SYSTEM_CURRENCY_REQUEST,
  };
};

export const getSystemCurrencySuccess = (prop) => {
  return {
    type: GET_SYSTEM_CURRENCY_SUCCESS,
    payload: prop,
  };
};

export const getSystemCurrencyFailure = (errors) => {
  return {
    type: GET_SYSTEM_CURRENCY_FAIL,
    payload: { errors },
  };
};

export const getSystemCurrencyLoading = (loading) => {
  return {
    type: GET_SYSTEM_CURRENCY_LOADING,
    payload: loading,
  };
};

// Deactivate Currency Rate Actions
export const deactivateCurrencyRateRequest = (prop) => {
  return {
    type: DEACTIVATE_CURRENCY_RATE_REQUEST,
    payload: prop,
  };
};

export const deactivateCurrencyRateSuccess = (prop) => {
  return {
    type: DEACTIVATE_CURRENCY_RATE_SUCCESS,
    payload: prop,
  };
};

export const deactivateCurrencyRateFailure = (errors) => {
  return {
    type: DEACTIVATE_CURRENCY_RATE_FAIL,
    payload: { errors },
  };
};

export const deactivateCurrencyRateLoading = (loading) => {
  return {
    type: DEACTIVATE_CURRENCY_RATE_LOADING,
    payload: loading,
  };
};

// Delete Currency Rate Actions
export const deleteCurrencyRateRequest = (prop) => {
  return {
    type: DELETE_CURRENCY_RATE_REQUEST,
    payload: prop,
  };
};

export const deleteCurrencyRateSuccess = (prop) => {
  return {
    type: DELETE_CURRENCY_RATE_SUCCESS,
    payload: prop,
  };
};

export const deleteCurrencyRateFailure = (errors) => {
  return {
    type: DELETE_CURRENCY_RATE_FAIL,
    payload: { errors },
  };
};

export const deleteCurrencyRateLoading = (loading) => {
  return {
    type: DELETE_CURRENCY_RATE_LOADING,
    payload: loading,
  };
};
